import { render, staticRenderFns } from "./MyLabel.vue?vue&type=template&id=df585936&"
import script from "./MyLabel.vue?vue&type=script&lang=js&"
export * from "./MyLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports